import React from "react";
import styled from "styled-components";
import { onlyText } from "react-children-utilities";
import { Button } from "baseui/button";
import { BiCopy } from "react-icons/bi";

const CopyContainer = styled.div`
	display: grid;
	grid-template-columns: auto 2rem;
`;

const Copy = (props: any) => {
	const doCopy = () => {
		navigator.clipboard.writeText(onlyText(props.children));
	};

	return (
		<CopyContainer style={props.style}>
			<div>{props.children}</div>{" "}
			<div>
				<BiCopy
					onClick={doCopy}
					style={{ color: "#cccccc", cursor: "pointer" }}
				/>
			</div>
		</CopyContainer>
	);
};
export default Copy;
